import IcCheck from './IcCheck'

export default IcCheck
